import { head, drop } from 'lodash';
import InventoryUnit from './inventory_unit';
import LayoutPosition from './layout_position';

export default class LayoutProduct {
  // eslint-disable-next-line max-params
  constructor(id, name, inventory_units, total_available, total_placed_inventory, shape, total_active_placed_inventories) {
    this.id = id;
    this.name = name;
    this.inventories = inventory_units;
    this.totalAvailableInventories = total_available;
    this.totalPlacedInventories = total_placed_inventory;
    this.totalActivePlacedInventories = total_active_placed_inventories;
    this.shape = shape;
  }

  static fromAttributes({ id, name, available_inventories, total_available, total_placed_inventory, shape, total_active_placed_inventories }) {
    return new LayoutProduct(
      id,
      name,
      available_inventories.map(unit => InventoryUnit.fromAttributes(unit)),
      total_available,
      total_placed_inventory,
      shape,
      total_active_placed_inventories
    );
  }

  placeInventory() {
    if (this.hasNoMoreInventories()) return;
    const inventory = head(this.inventories);
    this.inventories = drop(this.inventories, 1);
    this.totalPlacedInventories += 1;
    return new LayoutPosition(
      null,
      0,
      0,
      true,
      null,
      'Untitled',
      this.shape,
      inventory.id,
      this.name
    )
  }

  unplaceInventory(inventoryUnitId) {
    const inventory = new InventoryUnit(inventoryUnitId);
    this.inventories = [...this.inventories, inventory];
    this.totalPlacedInventories -= 1;
  }

  hasNoMoreInventories() {
    return this.totalPlacedInventories >= this.totalAvailableInventories;
  }
}
